import { gql } from 'urql';

export const RETORNABLES_TIPOS_QUERY = gql`
  query RetornablesTipos($search: String, $activo: Boolean) {
    retornablesTipos(search: $search, activo: $activo) {
      id
      codigo
      nombre
      descripcion
      categoria
      esRetornable
      controlaSaldo
      unidad
      capacidadUnidades
      activo
    }
  }
`;

export const RETORNABLES_CUENTA_QUERY = gql`
  query RetornablesCuentaCorriente($filtro: RetornablesCuentaFiltro) {
    retornablesCuentaCorriente(filtro: $filtro)
  }
`;

export const RETORNABLES_CUSTODIA_QUERY = gql`
  query RetornablesCustodia($tipoId: ID) { retornablesCustodia(tipoId: $tipoId) }
`;

export const REGISTRAR_MOVIMIENTO_RETORNABLES = gql`
  mutation RegistrarMovimientoRetornables($input: RegistrarMovimientoRetornablesInput!) {
    registrarMovimientoRetornables(input: $input)
  }
`;

export const REVERTIR_MOVIMIENTO_RETORNABLES = gql`
  mutation RevertirMovimientoRetornables($input: RevertirMovimientoRetornablesInput!) {
    revertirMovimientoRetornables(input: $input)
  }
`;

export const CREATE_RETORNABLE_TIPO = gql`
  mutation CreateRetornableTipo($input: RetornableTipoInput!) {
    createRetornableTipo(input: $input) { id codigo nombre activo capacidadUnidades descripcion }
  }
`;

export const UPDATE_RETORNABLE_TIPO = gql`
  mutation UpdateRetornableTipo($id: ID!, $input: RetornableTipoInput!) {
    updateRetornableTipo(id: $id, input: $input) { id codigo nombre activo capacidadUnidades descripcion }
  }
`;

export const RETORNABLES_MOVIMIENTOS_QUERY = gql`
  query RetornablesMovimientos($filtro: RetornablesMovimientosFiltro) {
    retornablesMovimientos(filtro: $filtro) {
      id
      sucursalId
      tipoId
      guiaId
      fojaId
      repartoId
      clienteId
      choferId
      fleteroId
      movimiento
      cantidad
      estado
      detalle
      tipoNombre
      clienteNombre
      sucursalNombre
      fecha
    }
  }
`;

export const RETORNABLES_SALDOS_QUERY = gql`
  query RetornablesSaldos($sucursalId: ID, $tipoId: ID, $clienteId: ID, $choferId: ID, $fleteroId: ID) {
    retornablesSaldos(sucursalId: $sucursalId, tipoId: $tipoId, clienteId: $clienteId, choferId: $choferId, fleteroId: $fleteroId) {
      sucursalId
      tipoId
      clienteId
      choferId
      fleteroId
      saldo
    }
  }
`;

export const ASIGNAR_RETORNABLES = gql`
  mutation AsignarRetornables($input: AsignarRetornablesInput!) {
    asignarRetornables(input: $input) { id movimiento estado cantidad fecha }
  }
`;

export const DEVOLVER_RETORNABLES = gql`
  mutation DevolverRetornables($input: DevolverRetornablesInput!) {
    devolverRetornables(input: $input) { id movimiento estado cantidad fecha fojaId clienteId choferId fleteroId }
  }
`;

export const AJUSTAR_RETORNABLES = gql`
  mutation AjustarRetornables($input: AjustarSaldoRetornablesInput!) {
    ajustarSaldoRetornables(input: $input) { id movimiento estado cantidad detalle fecha }
  }
`;

export const RETORNABLES_EN_CIRCULACION = gql`
  query RetornablesEnCirculacion($sucursalId: ID!) {
    retornablesEnCirculacion(sucursalId: $sucursalId) {
      id
      repartoId
      guiaId
      tipoId
      cantidad
      estado
    }
  }
`;
